import { Button, Drawer, Space } from "antd";
import {
  AiOutlineClose,
  AiOutlineFacebook,
  AiOutlineLinkedin,
} from "react-icons/ai";
import Avatar from "../../../assets/user.png";
import { FiEdit, FiTwitter } from "react-icons/fi";
import { IoLogoInstagram } from "react-icons/io5";
import { RiMailSendLine } from "react-icons/ri";
import { useEffect, useState } from "react";
import fetchTotalDue from "../../../services/fetchTotalDue";
import formatMoney from "../../../utils/formatMoney";
import SocialsPannel from "./SocialsPanel";
import ImpodatesPannel from "./ImpodatesPanel";
import FavouratesPannel from "./FavouratesPanel";
const { startCase } = require("lodash");
export default function DetailsPannel({
  isVisible,
  setVisible,
  selected,
}: any) {
  const [socialPanel, setSocialPanel] = useState(false);
  const [impodatesPanel, setImpodatesPanel] = useState(false);
  const [favouratesPanel, setFavouratesPanel] = useState(false);
  const [totalDue, setTotalDue] = useState(0);

  const handleFetchTotalDue = async () => {
    const response = await fetchTotalDue(selected.account);
    setTotalDue(response[0].total);
  };
  useEffect(() => {
    handleFetchTotalDue();
  }, [selected]);
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Customer Details</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="bg-white grid grid-cols-12  rounded-md -mt-6 h-full">
        <div className="cols-span-4 sm:col-span-4 h-auto border-r p-4">
          <div className="flex flex-col items-center">
            <div className=" flex justify-center items-center">
              <div className="flex justify-center items-center w-32 h-32 rounded-full bg-gray-300 p-1">
                <div className="flex justify-center items-center bg-gray-300 rounded-full w-full h-full">
                  <img
                    src={Avatar}
                    alt=""
                    className="w-full h-full rounded-full"
                  />
                </div>
              </div>
            </div>
            <div className="my-2">
              {startCase(selected?.name?.toLowerCase())}
            </div>
            <div className="w-full text-center bg-gray-200  rounded-lg border-t p-2 text-black mb-4">
              {selected?.segment?.name}
            </div>

            <div className="w-full text-center p-2 text-black mb-4 flex">
              <div className="w-1/2 text-center bg-toyota  rounded-lg border-t p-2 text-white mr-1 flex items-center">
                <RiMailSendLine /> <span className="ml-2">SMS</span>
              </div>
              <div className="w-1/2 text-center bg-toyota  rounded-lg border-t p-2 text-white ml-1 flex items-center">
                <RiMailSendLine /> <span className="ml-2">Email</span>
              </div>
            </div>

            <div className="border p-2 text-black flex w-full flex-col justify-center items-center">
              <div className="">Total Amount Due</div>
              <div className="font-bold mx-2">{formatMoney(totalDue)}</div>
            </div>
            <div className=" text-gray-600 w-full">
              <div className="flex justify-between my-2 border-b py-3">
                <div className="font-bold">Social Networks</div>
                <button onClick={() => setSocialPanel(true)}>
                  <FiEdit />
                </button>
              </div>
              <div className="flex items-center my-2">
                <FiTwitter />
                <span className="ml-2">
                  {selected?.twitter ? selected?.twitter : `-`}
                </span>
              </div>
              <div className="flex items-center my-2">
                <AiOutlineFacebook />
                <span className="ml-2">
                  {selected?.facebook ? selected?.facebook : `-`}
                </span>
              </div>
              <div className="flex items-center my-2">
                <AiOutlineLinkedin />
                <span className="ml-2">
                  {selected?.linkedin ? selected?.linkedin : `-`}
                </span>
              </div>

              <div className="flex items-center my-2">
                <IoLogoInstagram />
                <span className="ml-2">
                  {selected?.instagram ? selected?.instagram : `-`}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="cols-span-8 sm:col-span-8 p-4">
          <div className="border-b pb-4 uppercase font-bold">
            Account Details
          </div>
          <div className="">
            <div className="flex justify-between items-center">
              <div>Full Name</div>
              <div className="font-bold">
                {startCase(selected?.name?.toLowerCase())}
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div>Account</div>
              <div className="font-bold">{selected?.account}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Telephone</div>
              <div className="font-bold">{selected?.phone}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Mobile</div>
              <div className="font-bold">{selected?.mobile}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Email</div>
              <div className="font-bold">{selected?.email}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Segment</div>
              <div className="font-bold">{selected?.segment?.name}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Address 1</div>
              <div className="font-bold">{selected?.address1}</div>
            </div>
            <div className="flex justify-between items-center">
              <div>Address 2</div>
              <div className="font-bold">{selected?.address3}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Address 3</div>
              <div className="font-bold">{selected?.address3}</div>
            </div>

            <div className="flex justify-between items-center">
              <div>Address 4</div>
              <div className="font-bold">{selected?.address4}</div>
            </div>
          </div>
          <div className="">
            <div className="border-b pb-4  mt-8 uppercase font-bold flex justify-between">
              <div className="">Important Dates</div>
              <button onClick={() => setImpodatesPanel(true)}>
                <FiEdit />
              </button>
            </div>
          </div>
          <div className="">
            <div className="border-b pb-4  mt-8 uppercase font-bold flex justify-between">
              <div className="">Favourates & Hobbies</div>
              <button onClick={() => setFavouratesPanel(true)}>
                <FiEdit />
              </button>
            </div>
          </div>
        </div>
      </div>

      <SocialsPannel
        isVisible={socialPanel}
        setVisible={setSocialPanel}
        selected={selected}
      />
      <ImpodatesPannel
        isVisible={impodatesPanel}
        setVisible={setImpodatesPanel}
        selected={selected}
      />

      <FavouratesPannel
        isVisible={favouratesPanel}
        setVisible={setFavouratesPanel}
        selected={selected}
      />
    </Drawer>
  );
}
